/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Humiditysetpoint1Inputs */



/**
* | output |
* | --- |
* | "Humidity setpoint" |
*
* @param {Ahu_History_Key_Humiditysetpoint1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_humiditysetpoint1 = /** @type {((inputs?: Ahu_History_Key_Humiditysetpoint1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Humiditysetpoint1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne d'humidité")
});
export { ahu_history_key_humiditysetpoint1 as "ahu_history_key_humiditySetpoint" }